import React, { createElement } from 'react';
import Style from './index.module.scss';

export interface RowProps {
    nodeId?: string;
    style?: object;

    justifyContent: string;
    alignItems: string;
    children: any;
    width: number | string;
    isCenter: boolean
}

const Row: React.FC<RowProps> = (props) => {
    const { nodeId, justifyContent, alignItems, children, style, width, isCenter } = props;

    return (
        <div
            id={nodeId}
            className={Style.wrap}
            style={{
                width,
                ...(isCenter ? { marginLeft: 'auto', marginRight: 'auto' } : {}),
                justifyContent,
                alignItems,
                ...style,
            }}
        >
            {children}
        </div>
    );
};

Row.displayName = '行容器';

export default Row;
